import { createContext, useReducer, useState } from 'react';
import {
    BrowserRouter,
    Routes,
    Route,
  } from 'react-router-dom'
import { Header, MusicPlayer} from '../Components/components';
import {Home, NewSongs, OldSongs, PlayList, PlaySong, Profile,Admin, Login, Signup, ForgotPassword} 
from '../Pages/pages'
import { initialState, reducer } from '../Reducer/useReducer';


export const SongContext=createContext()
export const UserContext=createContext()
export const PlaylistUse=createContext("")

function lastPlayingSong(state){
    const USER_STORAGE=JSON.parse(localStorage.getItem("sangeetUser"))
    
    return state?USER_STORAGE.lastPlayingSong:
    {sName:'Zindagi Ka Safar',song:"https://pwdown.com/7211/04 Zindagi Ka Safar.mp3",sImage:
    "https://i.ibb.co/qD7ZKYY/Art-350.jpg",sDuration: "04:17"}
}

export default function Routes1(){
    const [state, dispatch] = useReducer(reducer, initialState)
    const [songs,setSong]=useState(lastPlayingSong(state))
    const [songGroup,setSongGroup]=useState([])
    const [playlistUpdate,setPlaylistUpdate]=useState(0)

    const ADMIN_PATH=process.env.REACT_APP_ADMIN_PATH
    return(
        <>
            <BrowserRouter>
                <UserContext.Provider value={{state,dispatch}}>
                    <SongContext.Provider value={{songs,setSong,songGroup,setSongGroup}}>
                        <PlaylistUse.Provider value={{playlistUpdate,setPlaylistUpdate}}>
                            <Header/>
                            <Routes>
                                <Route path="/" element={<Home/>}/>
                                <Route path="profile" element={<Profile/>}/>
                                <Route path="new_song" element={<NewSongs/>} />
                                <Route path="old_song" element={<OldSongs/>} />
                                <Route path="play_list" element={<PlayList/>}/>
                                <Route path="login" element={<Login/>}/>
                                <Route path="forgot_password" element={<ForgotPassword/>}/>
                                <Route path="signup" element={<Signup/>}/>
                                <Route path={ADMIN_PATH} element={<Admin/>}/>
                                <Route path="new_song/:id" element={<PlaySong/>}/>
                                <Route path="old_song/:id" element={<PlaySong/>}/>
                            </Routes>
                            <MusicPlayer/>
                        </PlaylistUse.Provider>
                    </SongContext.Provider>
                </UserContext.Provider>
            </BrowserRouter>
            {/* <BrowserRouter>
                <Routes>
                    <Route path="/login" element={<Login/>}/>
                    <Route path="/forgot_password" element={<ForgotPassword/>}/>
                    <Route path="/signup" element={<Signup/>}/>
                    <Route path="/admin" element={<Admin/>}/>
                </Routes>
             
            </BrowserRouter> */}
        </>
    );
}

